import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Card, CardBody } from 'reactstrap'

import { number } from '../../../helpers'

export default function CustomersReportForm({ report, params, setParams, onSubmit, loading }) {	

	return (
		<React.Fragment>
			<Card>
				<CardBody>
					<p className='bold mb-0'>Clientes con fecha entre:</p>
					<Form.Control 
						type="date"
						value={params.from}
						onChange={e => setParams({...params, from: e.target.value})}
					/>
					<p className='bold mb-0 mt-10'>hasta el dia:</p>
					<Form.Control 
						type="date"
						value={params.until}
						onChange={e => setParams({...params, until: e.target.value})}
					/>
					<Button 
						color='primary' 
						className='mt-15' 
						onClick={onSubmit}
						disabled={loading}
					>
						Generar Reporte{" "}
						{ loading && <Spinner animation='border' size="sm" /> }
					</Button>
				</CardBody>
			</Card>
			{ report && (
				<Card>
					<CardBody>
						<p>Visualizando el reporte con clientes desde el <b>{report.params.from}</b> hasta <b>{report.params.until}</b></p>
						<p><b>Total de Registros: </b>{number(report.data.total)} clientes</p>
						<p><b>Consultado el: </b>{report.data.consult_at}</p>
					</CardBody>
				</Card>
			)}
		</React.Fragment>
	)
}